module.exports = __webpack_public_path__ + "static/media/webdevelopment.eb01c137.jpg";